import axios, { AxiosRequestConfig, AxiosError } from 'axios';

export interface APIError {
    code: string;
    message: string;
}

export type APIRoute = { name: string; parameters?: any };
export type APIResponse<T> = { success: boolean; content: T | APIError };

function handleError<T>(error: AxiosError): APIResponse<T> {
    if ((<AxiosError>error).response !== undefined) {
        return {
            success: false,
            content: <APIError>{
                code: ((<AxiosError>error).response?.data as APIResponse<APIError>).content?.code || '',
                message: ((<AxiosError>error).response?.data as APIResponse<APIError>).content?.message || '',
            },
        };
    }
    return {
        success: false,
        content: <APIError>{
            code: '-1',
            message: 'Request timed out',
        },
    };
}

export async function get<T>(route: APIRoute, config: AxiosRequestConfig = {}): Promise<APIResponse<T>> {
    try {
        config.headers = {
            'X-Requested-With': 'XMLHttpRequest',
        };
        const response = await axios.get((<any>window).route('api.' + route.name, route.parameters), config);
        return response.data as APIResponse<T>;
    } catch (exception) {
        return handleError(<AxiosError>exception);
    }
}

export async function post<T>(route: APIRoute, data?: any, config: AxiosRequestConfig = {}): Promise<APIResponse<T>> {
    try {
        config.headers = {
            'X-Requested-With': 'XMLHttpRequest',
        };
        const response = await axios.post((<any>window).route('api.' + route.name, route.parameters), data, config);
        return response.data as APIResponse<T>;
    } catch (exception) {
        return handleError(<AxiosError>exception);
    }
}

export default {
    get,
    post,
};
